import React, { useState, useEffect } from "react";
import { Card, CardBody, Row, Col } from "reactstrap";
import { ReactComponent as CrossIcon } from "../../assets/utils/images/svgs/Cross.svg";
import { ReactComponent as TickIcon } from "../../assets/utils/images/svgs/Tick.svg";
import { toast } from "react-toastify";
import { useEvents, useUpdateCommunication } from "Api/Profile";

const Check = () => <TickIcon color="#28a745" fontSize={"12px"} />;
const Cross = () => <CrossIcon color="#dc3545" fontSize={"12px"} />;

const Preferences = ({ data }) => {
  const [roles, setRoles] = useState([]);
  const { trigger: updateCommunication } = useUpdateCommunication();

  const { data: eventsResponse } = useEvents();

  useEffect(() => {
    if (!data || !eventsResponse) return;

    const communicationData = eventsResponse?.events || [];

    const storedRoles =
      JSON.parse(localStorage.getItem("USER_ROLES")) || [];

    const roleKeys = storedRoles.filter(role => role !== "admin");

    const roleTitles = {
      coordinator: "Coordinator",
      requestor: "Melder",
      substitutor: "Vervanger"
    };

    const groupedRoles = {};

    communicationData.forEach(item => {
      const roleName = item.roleName;

      if (!roleKeys.includes(roleName)) return;

      if (!groupedRoles[roleName]) {
        groupedRoles[roleName] = {
          title: roleTitles[roleName] || roleName,
          items: []
        };
      }

      const apiRole = data?.communication?.[roleName] || [];

      const apiItem = apiRole.find(
        comm => Number(comm.iEventType) === Number(item.iComEventId)
      );

      groupedRoles[roleName].items.push({
        key: item.name,
        iComEventId: item.iComEventId,
        name: item.name,
        role: roleName,
        hasSms: Object.prototype.hasOwnProperty.call(apiItem || {}, "bSms"),
        hasMail: Object.prototype.hasOwnProperty.call(apiItem || {}, "bMail"),
        mail: apiItem?.bMail === 1,

        hasPush: Object.prototype.hasOwnProperty.call(apiItem || {}, "bPushNotification"),
        push: apiItem?.bPushNotification === 1,
        sms: apiItem?.bSms === 1,
      });
    });

    setRoles(Object.values(groupedRoles));
  }, [data, eventsResponse]);


  const handleClick = (roleType, notificationType, eventType, index, itemIndex) => {


    if (eventType === "sms" && !roles[index]?.items[itemIndex]?.hasSms) {
      return;
    }

    const apiKeyMap = {
      mail: "bMail",
      push: "bPushNotification",
      sms: "bSms",
    };

    const apiKey = apiKeyMap[eventType];
    const currentValue = roles[index]?.items[itemIndex]?.[eventType];

    if (currentValue === undefined) {
      console.warn("Current value is undefined. Check eventType mapping.");
      return;
    }

    const payload = {
      iAdminId: data?.profileList?.iAdminId,
      role: roleType.toLowerCase(),
      notification_type: notificationType,
      eventType: apiKey,
      [apiKey]: !currentValue ? 1 : 0,
    };

    updateCommunication({
      data: payload
    })
      .then((res) => {
        if (res.check !== undefined) {

          const newRoles = [...roles];
          newRoles[index].items[itemIndex][eventType] = res.check === 1;
          setRoles(newRoles);
        } else {
          toast.error("Fout bij bijwerken van instelling");
        }
      })
      .catch((err) => {
        console.error("API error:", err);
        toast.error("Fout bij bijwerken van instelling");
      });
  };

  return (
    <Card className=" main-card no-shadow gebruikers-view" style={{ height: "100%" }}>
      <CardBody className="algemeen ">
        <h5 className="mb-4">Communicatievoorkeuren</h5>
        {roles.length === 0 && (
          <p className="text-center text-muted">
            Er zijn geen rollen beschikbaar voor deze gebruiker.
          </p>
        )}
        {roles.map((section, index) => (
          <div key={index} className="mb-4 border-bottom">
            <div className="fw-bold mb-2">
              {
                section.title === 'coordinator' ? 'Coordinator' :
                  section.title === 'substitutor' ? 'Vervanger' :
                    section.title === 'Requestor' ? 'Melder' :
                      section.title
              }
            </div>

            <Row className="mb-4 fw-bold">
              <Col md="6"></Col>
              <Col md="2">Mail</Col>
              <Col md="2">Push-bericht</Col>
              <Col md="2">SMS</Col>

            </Row>

            {section.items
              .sort((a, b) => {
                const priorityOrder = {
                  "Dagdelen Added": 1,
                  "Opmerking Added": 2,
                };
                const priorityA = priorityOrder[a.key] || 999;
                const priorityB = priorityOrder[b.key] || 999;

                return priorityA - priorityB;
              }).map((item, i) => (
                <Row key={i} className="align-items-center mb-2">
                  <Col md="6">{item.name}</Col>

                  <Col
                    md="2"
                    className="cursor-pointer"
                    onClick={() => {
                      if (!item.hasMail) return;

                      handleClick(item.role, item.iComEventId, "mail", index, i);
                    }}
                  >
                    {!item.hasMail ? "-" : item.mail ? <Check /> : <Cross />}
                  </Col>

                  <Col
                    md="2"
                    className="cursor-pointer"
                    onClick={() => {
                      if (!item.hasPush) return;

                      handleClick(item.role, item.iComEventId, "push", index, i);
                    }}
                  >
                    {!item.hasPush ? "-" : item.push ? <Check /> : <Cross />}
                  </Col>

                  <Col
                    md="2"
                    className="cursor-pointer"
                    onClick={() => handleClick(item.role, item.iComEventId
                      , "sms", index, i)}
                  >
                    {!item.hasSms ? "-" : item.sms ? <Check /> : <Cross />}
                  </Col>
                </Row>
              ))}
          </div>
        ))}
      </CardBody>
    </Card>
  );
};

export default Preferences;